export const POST_SIGNIN_REQUEST = "POST_SIGNIN_REQUEST" as const;
export const POST_SIGNIN_SUCCESS = "POST_SIGNIN_SUCCESS" as const;
export const POST_SIGNIN_FAILURE = "POST_SIGNIN_FAILURE" as const;

export const SET_LOGIN_REQUEST = "SET_LOGIN_REQUEST" as const;
export const SET_LOGOUT_REQUEST = "SET_LOGOUT_REQUEST" as const;

export const GET_USER_REQUEST = "GET_USER_REQUEST" as const;
export const GET_USER_SUCCESS = "GET_USER_SUCCESS" as const;
export const GET_USER_FAILURE = "GET_USER_FAILURE" as const;

export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS" as const;

export const GET_WORKOUTS_SUCCESS = "GET_WORKOUTS_SUCCESS" as const;


